<div class="mt-3">
  <mat-card>
    <div class="m-3">
      <div class="text-black pb-4">
        <h6>{{ 'name_funnel' | translate }}</h6>
        <div class="text-dark">
          <app-text-field [formControl]="funnelForm.controls.name" [error]="!funnelForm.valid"></app-text-field>
          @if (funnelForm.controls['name'].status === 'INVALID') {
            <mat-hint class="text-danger"> {{ 'field_cannot_be_empty' | translate }}. </mat-hint>
          }
        </div>
      </div>

      <!--      <div class="pb-2">-->
      <!--        <h6 class="text-black mb-1">Відповідальний за автоматично додані угоди</h6>-->
      <!--        <app-dropdown-->
      <!--          [items]="list"-->
      <!--          [closeOnSelect]="true"-->
      <!--        >-->
      <!--        </app-dropdown>-->
      <!--      </div>-->

      <div>
        <h6 class="text-black mb-1">{{ 'main_currency' | translate }}</h6>
        <app-dropdown
          bindValue="value"
          [closeOnSelect]="true"
          [items]="CURRENCY"
          [formControl]="funnelForm.controls.currency"
        ></app-dropdown>
        <div class="small-text pt-2">
          {{ 'the_dollar_rate_is_calculated_by' | translate }} {{ this.dollar }} {{ 'UAH' | translate }}.<span>*</span>
        </div>
      </div>
    </div>
    <div class="m-3 d-flex justify-content-between">
      <app-button [disabled]="(funnelData && !hasChange) || funnelForm.invalid" (onChangeClick)="onSaveFunnel()">{{
        'save' | translate
      }}</app-button>
      <app-button btnType="stroked" (onChangeClick)="onDeleteFunnel()">{{ 'delete_funnel' | translate }}</app-button>
    </div>
  </mat-card>
</div>
